export class JobAlert {

    public name: string = '';
    public email: string = '';
    public fullName: string = '';
    public textCriteria: string = '';
    public status: number = 0;
    public isActive: number = 0;
    public activationHash: string = '';
    public companyCode: string = '';
    public location: string = '';
    public jobType: string = '';
    public jobSkills!: number;
    public industry!: number;
    public jobConfigDetails: string = '';

}
